import i18n from "../../../language/main/i18n";
import {
  ELanguageTypes,
  EnumLanguageTypes,
} from "../../../language/main/LanguageEnums";
import LanguageService from "../../../language/main/LanguageService";

interface ILanguageItem {
  id: string;
  lngKey: string;
}

export default class AppLanguageService {

  private static fallbackLangaugeId : string = ELanguageTypes.en.valueOf();

  //lngItems
  private static _lngItems: ILanguageItem[] = [];
  public static setLngItems(it: ILanguageItem[]) { this._lngItems = it; }

  //currentId
  private static _currentLngId: string = this.fallbackLangaugeId;
  public static get currentId(): string { return this._currentLngId; }   
  public static set currentId(id: string) { 
    const result = this.getIds().find((it) => it == id)
    if(result != undefined) { this._currentLngId = id; return; } 
    //set fallback languageId
    this._currentLngId = this.fallbackLangaugeId;
  }

  //ids
  public static getIds(): string[] { return this._lngItems.map((it) => it.id); }
  public static get lngKeys(): string[] { return this._lngItems.map((it) => it.lngKey); }

  //getter
  public static getKeyById(id: string): string | undefined {
    return this._lngItems.find((it) => it.id == id)?.lngKey;
  }

  public static getIdByKey(key: string): string { 
    try {
      return this._lngItems.find((it) => it.lngKey == key)?.id!!; 
    } catch (e) {
      //return fallback language
      return this._currentLngId;
    }
  }

  //setter
  public static setLanguageById(id: string | undefined) { i18n.changeLanguage(id); }
  public static setLanguageByKey(lngKey: string) { i18n.changeLanguage(this.getIdByKey(lngKey)); }

  constructor() {
    new Factory();
  }
}

class Factory {
  constructor() {
    this.setLanguageItemsByIds();
    this.setBrowserLanguage();
  }


  private setBrowserLanguage() {
    AppLanguageService.currentId = new LanguageService().getBrowserLanguage();;
    AppLanguageService.setLanguageById(AppLanguageService.currentId);
  }

  private setLanguageItemsByIds(): void {
    const results: ILanguageItem[] = [];
    const ids = EnumLanguageTypes.getArrayOfIds();
    ids.map((it, idx) => { results.push({ id: it, lngKey: "lng_" + it }); });
    AppLanguageService.setLngItems(results);
  }
}
